import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { IcoStar } from '@myrealtrip/web-icons';
import { Text } from '@myrealtrip/web-ui';

interface Props {
  rating: number;
  count: number;
}

const ReviewRating = ({ rating, count }: Props) => {
  const { colors } = useTheme();

  return (
    <Container>
      <IconWrapper>
        <IcoStar size={16} color={colors.yellow.s400} />
      </IconWrapper>
      <Rating typography="paragraphBold14">{rating}</Rating>
      <Text typography="paragraphNormal14" color={colors.gray.s700}>
        ({count})
      </Text>
    </Container>
  );
};

export default ReviewRating;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div``;

const Rating = styled(Text)`
  margin: 0 2px 0 4px;
`;
